module.exports = __webpack_public_path__ + "static/wix_2-26809a9befb03e054cac8b2021f8c80a.png";